import React, { Component, useRef } from 'react';
import { connect } from 'react-redux';
import { assessmentActions } from "../../../../../../_actions";
import { CONST } from '../../../../../../_config';
import Top5Talents from './Top5Talents';
import Resources from './Resources';
import moment from 'moment';
import { MdClose } from "react-icons/md";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { MdOutlineArrowDropDown } from 'react-icons/md';

import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay, Scrollbar, A11y, loop } from 'swiper/modules';

// function SampleNextArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       style={{ ...style, display: "block" }}
//       onClick={onClick}
//     >
//       <IoIosArrowDropright style={{ fontSize: "2em" }} />
//     </div>
//   );
// }

// function SamplePrevArrow(props) {
//   const { className, style, onClick } = props;
//   return (
//     <div
//       className={className}
//       style={{ ...style, display: "block", background: "green" }}
//       onClick={onClick}
//     >
//       <IoIosArrowDropright style={{ fontSize: "2em" }} />
//     </div>
//   );
// }


class BackSummary extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.state = {
      showMainPage: true,
      showFilter: false,
      showValue: '',
      showTabView: 2,
      activeTab: 1,
      isTest: true,
      crrExpertId: false,
      rating: 0

    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // this.props.dispatch(assessmentActions.getExpertDetailsList());
  }


  exportPDFWithComponent = () => {
    if (this.pdfExportComponent.current) {
      this.pdfExportComponent.current.save();
    }
  };


  closeFilter = (check1, check2) => {
    this.setState({ showFilter: check1, showValue: check2 });
  }

  openSurveyResponse = () => {
    this.setState({ showOverview: false });

  }

  closeResponseAnalytics = () => {
    this.setState({ showOverview: true })
  }

  onOptionType = (value) => {
    this.setState({ optionType: value })
  }


  handleStrength = (params) => {
    let { handleThemeStrenght } = this.props;
    let { FilterValues } = this.state;
    let name = ''
    if (params && params.name) {
      name = params.name;
    }
    handleThemeStrenght(name, FilterValues);
    this.setState({ showMainPage: false })
  }


  handleMultifilterIndexScore2 = (finalFilter, name) => {

    let { handlAssessmentDashboard } = this.props;
    this.setState({
      FilterValues: finalFilter,
      ListName: name,
      showMainPage: true
    });

    handlAssessmentDashboard(finalFilter, true);

  }

  handleGOTOTheme = () => {
    this.setState({ showMainPage: true })
  }

  handleTabView = (value) => {
    this.setState({ showTabView: value })
  }

  setActiveTab = (tabNumber) => {
    this.setState({
      activeTab: tabNumber,
    });
  };

  handleOpenModalRating = (expertId) => {
    this.setState({ crrExpertId: expertId });
  };

  handleCloseModalRating = () => {
    this.setState({ crrExpertId: false });
  };

  handleReviewInput = (star) => {
    this.setState({ rating: star });
  }
  handleReviewSubmit = () => {
    let input = {
      "rating": this.state.rating.toString(),
      "expertId": this.state.crrExpertId
    }
    console.log("input--->", input)
    this.props.dispatch(assessmentActions.submitExpertRating(input));
    this.setState({ crrExpertId: false });
  }

  render() {


    let { getExpertOrderBookListData, showMyExpertList, handleTestPayment, userAssessmentExpertOrderPlaceData, handleInputExpertForm, bookExpert, crrCodeUserDetails, getAssessmenrEmployeeDetailsData, handleShowMainSummaryModal, EditDetailsFn, getAssessmentReportByEmpIDData, crrDetail, loading, getAssessmentDimensionsData, EditButtonFn, handleShowMainSummaryModalBack, contactExpertSection, handleExpertContactModal, topFiveTalent, handleExpertContactModalBack, assessment } = this.props;
    let { showMainPage, showTabView, crrExpertId } = this.state;

    let { getExpertDetailsListData } = assessment;
    function spliceDecimal(no) {
      if (no) {
        let str = no.toString();
        let first = str.split('.')[0];
        let second = str.split('.')[1];
        let second2 = second ? second.substring(0, 2) : ""
        let final = first + '.' + second2;
        if (second2) {
          return parseFloat(final).toFixed(2)
        } else {
          return no
        }
      } else {
        return 0
      }
    }

    let AssessmentList = []
    if (getAssessmentDimensionsData && getAssessmentDimensionsData.length > 0) {
      getAssessmentDimensionsData.forEach((element) => {
        AssessmentList.push({
          ...element,
          finalSum: (Number(element.count) * Number(element.rankSum))
        })
      })
      AssessmentList.sort((a, b) => (a.finalSum - b.finalSumSum))
    }

    console.log("contactExpertSection--111111111111111111111111->", contactExpertSection)


    let newList = []
    if (AssessmentList && AssessmentList.length > 0) {
      AssessmentList.forEach((element, index) => {

        let rank = (AssessmentList.length - index);

        let check = 0;
        if (showTabView === 1) {
          check = 1
        } else if (showTabView === 2 && (rank <= 5)) {
          check = 2
        } else if (showTabView === 3 && (rank <= 7)) {
          check = 3
        } else if (showTabView === 4 && (rank <= 10)) {
          check = 4
        }
        console.log("check--1->", check)

        let getIndex = newList.findIndex(prev => prev.bucket === element.bucket)
        if (getIndex === -1) {
          let temp = {
            "showCount": 0,
            "bucket": element.bucket,
            "colorCode": element.colorCode,
            "dimensions": [{
              "rank": rank,
              "check": check,
              "name": element.dimension,
              "count": element.count,
              "finalSum": element.finalSum,
              "colorCode": element.colorCode,
            }],
          }
          newList.push(temp)
        } else {
          newList[getIndex]["showCount"] += 1

          newList[getIndex]["dimensions"].push({
            "rank": rank,
            "check": check,
            "name": element.dimension,
            "count": element.count,
            "finalSum": element.finalSum,
            "colorCode": element.colorCode,
          })
        }



      });
    }


    let newV2List = [];
    if (newList && newList.length > 0) {
      for (var ix = 0; ix < newList.length; ix++) {
        let details = newList[ix];
        let temp = details;
        if (details && details.dimensions && details.dimensions.length > 0) {
          temp["dimensions"] = details.dimensions.sort((a, b) => (a.rank - b.rank));
        }
        newV2List.push(temp)
      }
    }



    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }

    function getTitle(element, type) {
      let itemName =
        type === 1
          ? "How to use - Talent every day?"
          : "How to deal with a person who has - Talent?";
      let final = itemName.replace("-", element.dimension.trim());
      //console.log("final--->", final.toString());
      return final.toString();
    }

    function getModifiedContent(text) {
      let text2 = "";
      if (text) {
        text2 = text
          .replace(/<\/?li[^>]*>/g, "@")
          .replace(/<\/?ul[^>]*>/g, "")
          .replace(/<\/?span[^>]*>/g, "")
          .replace(/<\/?p[^>]*>/g, "")
          .replace(/&nbsp;/g, "")
          .replace(/<\/?br[^>]*>/g, "")
          .replace(/<\/?b[^>]*>/g, "");
      }
      return text2 ? text2 : text;
    }

    function getBulletPoints(element, field) {
      let descX =
        element && element.details && element.details[field]
          ? element.details[field]
          : "";
      let descNew = "";
      if (descX) {
        let temp = getModifiedContent(descX);
        descNew = temp.split("@").filter((prev) => prev !== "");
      }
      return descNew;
    }

    function chunkList(array) {
      const chunkSize = 10;
      let list = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        list.push(chunk);
      }
      return list;
    }


    console.log("crrCodeUserDetails--------.", crrCodeUserDetails)


    let getBookedExpertList = [
      {
        "name": "01",
        "name": "Dr. Ashish Ambasta",
        "name": "",
        "name": "",
      }
    ]

    function getExpertDetails(ele, type, a, b) {
      let value = "";
      if (type === 1) {
        if (ele && ele[a]) {
          value = ele[a]
        }
      } else if (type === 2) {
        if (ele && ele[a] && ele[a][b]) {
          value = ele[a][b]
        }
      }
      return a === "rating" ? (value ? value : "NA") : value
    }
    return (
      <>

        <div className="w-full" >

          <div className="  ">

            {
              topFiveTalent ?
                <>
                  <div className=" space-y-6">

                    <Top5Talents
                      getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                      EditDetailsFn={EditDetailsFn}
                      EditButtonFn={EditButtonFn}
                      crrDetail={crrDetail}
                      handleShowMainSummaryModal={handleShowMainSummaryModal}
                      handleShowMainSummaryModalBack={handleShowMainSummaryModalBack}
                    />

                    <Resources />


                  </div>
                </> : null
            }



          </div>
        </div>
      </>
    );
  }
}


function mapStateToProps(state) {
  // ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard, assessment } = state;
  return {
    loggingIn,
    users,
    dashboard,
    assessment
  };
}
export default connect(mapStateToProps)(BackSummary);
